import { render, staticRenderFns } from "./CKEditorComponent.vue?vue&type=template&id=2d3ea3e7&"
import script from "./CKEditorComponent.vue?vue&type=script&lang=js&"
export * from "./CKEditorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports